import { useStripeProducts } from "../../../utils/context/stripe.context";

const useFetchEHRProducts = () => {
  const { products, loading, error } = useStripeProducts();
  // Filter products to only include EHR subscription packages
  const ehrPackages = products.filter((product) => product.metadata?.type === "ehr-subscription");

  return {
    ehrPackages,
    loading,
    error,
  };
};

export default useFetchEHRProducts;
